import { formatPrice } from './Products/getCalculatePriceDifferance';
import { CancellationFeeItem } from './Products/productFilter';

type CancellationFeeItemAPI = {
  [term: string]: {
    fee: {
      value: string;
      sku: string;
    };
    apply: string;
  };
};

const filterCancellationFeeList = (
  cancellationFees: string
): CancellationFeeItem[] | [] => {
  try {
    const fees = JSON.parse(cancellationFees)?.cancellation;
    return fees.map((item: CancellationFeeItemAPI) => {
      const term = Object.keys(item)[0];
      const { apply, fee } = item[term];
      return {
        apply,
        term,
        fees: formatPrice(Number(fee.value)),
        sku: fee.sku
      };
    });
  } catch (error) {
    console.error('Error parsing cancellation fees JSON:', error);
    return [];
  }
};

export default filterCancellationFeeList;
